// pages/Local.js
import React from 'react';

function Local() {
  return (
    <div>
      <h1>Local</h1>
      <p>Encontre-nos no mapa.</p>
    </div>
  );
}

export default Local;
